import React, { createContext, useCallback, useContext, useState } from 'react';
import { ContratarInfo, ModalType, Partner } from '../types/HomeTypes';

interface ModalContextValue {
  modal: ModalType;
  contratarInfo: ContratarInfo;
  selectedPartner: Partner | null;
  openModal: (type: ModalType, payload?: ModalPayload) => void;
  closeModal: () => void;
}

interface ModalPayload {
  contratarInfo?: ContratarInfo;
  partner?: Partner;
}

const ModalContext = createContext<ModalContextValue | null>(null);

export function ModalProvider({ children }: { children: React.ReactNode }) {
  const [modal, setModal] = useState<ModalType>(null);
  const [contratarInfo, setContratarInfo] = useState<ContratarInfo>({ serviceName: '', partnerName: '' });
  const [selectedPartner, setSelectedPartner] = useState<Partner | null>(null);

  const openModal = useCallback((type: ModalType, payload?: ModalPayload) => {
    if (payload?.contratarInfo) setContratarInfo(payload.contratarInfo);
    if (payload?.partner) setSelectedPartner(payload.partner);
    setModal(type);
  }, []);

  const closeModal = useCallback(() => {
    setModal(null);
  }, []);

  return (
    <ModalContext.Provider value={{ modal, contratarInfo, selectedPartner, openModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
}

export function useModal(): ModalContextValue {
  const ctx = useContext(ModalContext);
  if (!ctx) throw new Error('useModal must be used inside ModalProvider');
  return ctx;
}
